
import type { PropOptions } from 'vue';
import Vue from 'vue';
import ArrowDownIcon from './images/arrow-down.vue.svg';
import type { IOption } from './types';
import { jobSearchStatusKeys } from '@/components/partials/war-room-onboarding/constants';
import Dropdown from '@/components/common/Dropdown/Dropdown.vue';
import DropdownMenu from '@/components/common/Dropdown/DropdownMenu.vue';
import DropdownToggler from '@/components/common/Dropdown/DropdownToggler.vue';
import DropdownItem from '@/components/common/Dropdown/DropdownItem.vue';
import JobsProfileSection from '@/components/partials/jobs/JobsProfile/JobsProfileSection.vue';

interface IData {
  options: IOption[];
}

const OPTIONS: IOption[] = [
  {
    title: 'Actively Looking',
    description:
      '<div>I’m actively looking for a new role.</div><div>“Actively Looking” candidates get prioritized over candidates that are “Open to Offers”.</div>',
    color: '#2FB254',
    subhint: "We'll reach out to you as soon as we find an opportunity that matches your experience.",
    key: jobSearchStatusKeys.ACTIVELY_LOOKING,
  },
  {
    title: 'Open to Offers',
    description:
      '<div>I’m opportunistically looking for a new role, I would take a better opportunity if one came my way.</div>',
    color: '#5E79C5',
    hint: '🚀 Boost your job search',
    subhint: 'Update your status to "Actively Looking" to get priority within our program.',
    key: jobSearchStatusKeys.PASSIVELY_LOOKING,
  },
  {
    title: 'Not Interested',
    description:
      '<div>I’m not looking to leave my current role.</div><div>To get new offers, please update your status to “Actively Looking” or “Open to Offers”.</div>',
    color: '#797B86',
    subhint: 'If you want to receive offers from Bravado change your status to “Actively Looking” or “Open to Offers”',
    key: jobSearchStatusKeys.NOT_INTERESTED,
  },
];

export default Vue.extend({
  name: 'JobsProfileJobSearchStatus',
  components: {
    Dropdown,
    DropdownMenu,
    DropdownToggler,
    DropdownItem,
    ArrowDownIcon,
    JobsProfileSection,
  },
  props: {
    jobSearchStatus: {
      type: [String, null],
      default: null,
    } as PropOptions<string>,
    expiresAt: {
      type: [String, null],
      default: null,
    } as PropOptions<string>,
  },
  data(): IData {
    return {
      options: OPTIONS,
    };
  },
  computed: {
    selected(): IOption | undefined {
      return OPTIONS.find(option => option.key === this.jobSearchStatus);
    },
  },
});
